import './assets/scss/style-global.scss'; // 全站共用scss
import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import store from './store';
import { clickOutside } from './directive/clickOutside';
import PicIcon from './components/ui/svgicon/index.vue';
import {createGtm } from 'vue-gtm'
import {setupI18n} from './locales/i18n'


import VueFocusLoop from '@vue-a11y/focus-loop'//ADA focus重新導向
// import FocusLoop from './components/Focus/index.vue'//ADA focus重新導向 寫進本地端




let auth = process.env.NODE_ENV == 'prod' ? 'X0HzhgLsTDAFfyTxxW7XjQ' : 'k3hOpEwlkBHJVbl_50agzw'
let preview = process.env.NODE_ENV == 'prod' ? 'env-1' : 'env-4'

// console.log(auth, preview)


let app = createApp(App).use(router).use(store).use(VueFocusLoop).use(
  createGtm({
    id: 'GTM-MFGJJ2Z', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    queryParams: {
      // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
      gtm_auth: auth,
      gtm_preview: preview,
      gtm_cookies_win: 'x',
    },
  }),
);;
// app.component('FocusOut', FocusLoop) //ADA focus重新導向 寫進本地端 組件掛載                
setupI18n(app)




//iCon component register globally
app.component('iCon', PicIcon)
const requireAll = (requireContext) => requireContext.keys().map(requireContext);
const req = require.context('@/assets/svg', false, /\.svg$/);
requireAll(req);


app.directive('click-outside', clickOutside); // detect click out 
app.mount('#app')
